import React from 'react'
import AlertList from './AlertList'

const AlertComponent = ({ onBack }) => {
  return (
    <div className="alert-component">
      <AlertList onBack={onBack} />
    </div>
  )
}

export default AlertComponent
